import React from 'react';
import ShipmentMgmtListContainer from '../../containers/shipmentmng/ShipmentMgmtListContainer';

const ShipmentMngListPage = () => {
  return <ShipmentMgmtListContainer />;
};

export default ShipmentMngListPage;
